import React from 'react';
import { Link } from 'react-router-dom';
import logoFooter from '../images/logo_footer.png';

class Footer extends React.Component{

    constructor(props){
        super(props);

        this.state = {
        }
    }

    render(){
        return (
            <div className='footer-content'>
        <div className="row">
            <div className="col-md-12 d-flex footer-logo align-items-center">
                <a href="/clanek/skupina-sd">
                    <img src={logoFooter} alt="logo_footer"/>
                </a>
            </div>
        </div>

        <hr className="hr-black" />

        <div className="row footer-text">
            <div className="col-md-12 sd-hidden-xs">
                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="/o-spolecnosti">O společnosti</a> </div>
                    <div className="col-md-4 col-lg-3">PRODECO, a.s.</div>
                </div>

                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="https://sdas.jobs.cz/o-spolecnosti/#prodeco">Práce u nás</a></div>
                    <div className="col-md-4 col-lg-3">Důlní 437, Mostecké Předměstí</div>
                </div>
                
                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="/kontakty">Kontakty</a></div>
                    <div className="col-md-4 col-lg-3">Bílina, 418 01</div>
                </div>
                
                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="/clanek/fakturace">Fakturace</a></div>
                    <div className="col-md-4 col-lg-3"></div>
                </div>
                
                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="/clanek/ochrana-osobnich-udaju">Ochrana osobních údajů</a></div>
                    <div className="col-md-4 col-lg-3">prodeco@prodeco.cz</div>
                </div>

                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="/clanek/eticka-linka-oznamovatele">Etická linka oznamovatele</a></div>
                    <div className="col-md-4 col-lg-3">obchod@prodeco.cz</div>
                </div>

                <div className="row">
                    <div className="col-md-8 col-lg-9 footer-link"><a href="/clanek/cookies">Cookies</a></div>
                    <div className="col-md-4 col-lg-3"></div>
                </div>
            </div>

            <div className="col-xs-12 sd-visible-xs">
                <div className="col-12 footer-link"><a href="/o-spolecnosti">O společnosti</a></div>
                <div className="col-12 footer-link"><a href="https://sdas.jobs.cz/o-spolecnosti/#prodeco">Práce u nás</a></div>
                <div className="col-12 footer-link"><a href="/kontakty">Kontakty</a></div>
                <div className="col-12 footer-link"><a href="/clanek/fakturace">Fakturace</a></div>
                <div className="col-12 footer-link"><a href="/clanek/ochrana-osobnich-udaju">Ochrana osobních údajů</a></div>
                <div className="col-12 footer-link"><a href="/clanek/eticka-linka-oznamovatele">Etická linka oznamovatele</a></div>
                <div className="col-12 footer-link"><a href="/clanek/cookies">Cookies</a></div>

                <div className="col-12">&nbsp;</div>
                <div className="col-12">PRODECO, a.s.</div>
                <div className="col-12">Důlní 437, Mostecké Předměstí</div>
                <div className="col-12">Bílina, 418 01</div>
                <div className="col-12">prodeco@prodeco.cz</div>
                <div className="col-12">obchod@prodeco.cz</div>
            </div>
        </div>

        <div className="row mt-3 sd-hidden-xs">
            <div className="col-12 text-right">&copy; PRODECO, a.s</div>
        </div>

        <div className="actual-xs-footer">
            <hr />
        <div className="row mt-3">
            <div className="col-12 text-center">&copy; PRODECO, a.s</div>
        </div>
        </div>
        </div>
        )
    }
}

export default Footer;